import {ProfileInformations} from "templates"

const UserInitialsAvatar = ({ firstName = '', lastName = '' }: ProfileInformations) => {
  /* Detemine user first letter */
  const getUserFirstLetter = () => {
    return `${firstName[0]}${lastName[0]}`.toUpperCase() || '';
 };
  
  return (
      <div
        data-testid="firstLetter"
        className="d-flex rounded-circle mx-auto justify-content-center align-items-center profile_image profile_letter"
      >
       {getUserFirstLetter()}
      </div>
  );
}

export default UserInitialsAvatar;
